.issueTypeIcon {
	width: 16px;
	height: 16px;
}

.legendItem {
	display: flex;
	align-items: center;
	margin-bottom: 5px;
}

.legendItemText {
	margin-left: var(--jpo-common-base-spacing);
}
